export const FAQ_CONSTANTS = {
  SECTION_ID: 'faq',
  TITLE_ID: 'faq-title',
  SECTION_TITLE: 'Wedding FAQs',
  EMAIL: 'dimps.ashwin@gmail.com',
  
  FAQS: {
    ACCOMMODATION_IN_PUNE: {
      KEY: 'accommodation-pune',
      QUESTION: '🏡 Where can we stay in Pune?',
      ANSWER: `We'll be celebrating our Haldi, Sangeet, and Wedding in Pune on December 27th and 28th. \nFor our loved ones traveling from outside Pune, we'll be arranging comfortable accommodation near the venue for the night of December 27th.
Check-in will be at 3:00 PM on the 27th, and check-out time will be around 12:00 PM on December 28th. Once your RSVP is confirmed, we'll share all the stay and location details with you directly.
`,
    },
    ACCOMMODATION_MUMBAI: {
      KEY: 'accommodation-mumbai',
      QUESTION: '🌆 What about accommodation in Mumbai?',
      ANSWER: `Our Reception will be held in Mumbai on January 2nd, and we'll be arranging comfortable accommodation for the night of January 2nd for guests traveling from outside the city. 
Once your RSVP is confirmed, we'll share all the stay and location details with you directly.`,
    },
    VENUES: {
      KEY: 'venues',
      QUESTION: '🕐 How and when should we get to the venues?',
      ANSWER: `All event details, including timings and locations, are mentioned in the invite. 
      Please be sure to take a look!

      For guests travelling from outside the cities, both cities are well-connected by road, rail, and air. You’ll find several convenient options running frequently throughout the day.
All our venues are located in the city, so getting around should be smooth and convenient. However, please do not hesitate to reach out to us if you need help with arranging your commute to the venues.

If you’re joining us in Pune, we recommend arriving by December 27th so you don’t miss any of the pre-wedding festivities and fun! 💛

Punctuality = more time for masti! 💃🕺
`,
    },
    ATTIRE: {
      KEY: 'attire',
      QUESTION: '👗 What should we wear?',
      ANSWER: `No strict dress codes here 😊 just bring your best desi fashion game!
 Think colorful, festive, and totally you.`,
    },
    CONTACT: {
      KEY: 'contact',
      QUESTION: '📞 Who can I contact if I have questions?',
      ANSWER: ` If you’re unsure about travel, logistics, or anything wedding-related, reach out to either of our families (they’re basically our superhero team!)
Or drop us an email at dimps.ashwin@gmail.com!`,
    },
    INVITE: {
      KEY: 'invite',
      QUESTION: '💌 Wedding Invite Links',
      ANSWER: '',
      PDFS: {
        ENGAGEMENT: {
          LABEL: '💍 Engagement Invite',
          URL: '/invites/engagement-invite.pdf',
          FILENAME: 'Engagement_Dec_22.pdf'
        },
        HALDI: {
          LABEL: '🌟 Haldi Invite', 
          URL: '/invites/haldi-invite.pdf',
          FILENAME: 'Haldi_Dec_27.pdf'
        },
        WEDDING: {
          LABEL: '🤝 Wedding Invite',
          URL: '/invites/wedding-invite.pdf',
          FILENAME: 'Wedding_Dec_28.pdf'
        },
        RECEPTION: {
          LABEL: '🎉 Reception Invite',
          URL: '/invites/reception-invite.pdf',
          FILENAME: 'Reception_Jan_2.pdf'
        }
      }
    },
  },
};